import JobForm from "@container/job-form";
import AuthLayout from "@container/layout/auth";

export default function EmployerEditJobPage() {

    return (
        <AuthLayout withoutHeader>
            <div className="relative">
                <JobForm isEditMode />
            </div>
        </AuthLayout>
    )
}